import React from 'react';
import { X } from 'lucide-react';

const PizzulTip = ({ tip, onDismiss }) => {
  if (!tip) return null;

  return (
    <div
      className="fixed bottom-20 left-3 right-3 z-40 mx-auto flex max-w-xl items-center gap-3
        rounded-2xl border border-white/15 bg-[#101314]/95 p-3 shadow-2xl backdrop-blur-lg lg:bottom-5"
      role="status"
    >
      <img
        src={`/pizzul/${tip.pose}.png`}
        alt="Pizzul"
        className="h-14 w-14 shrink-0 object-contain"
      />
      <div className="min-w-0 flex-1">
        <p className="text-xs font-black uppercase tracking-[0.16em] text-cyan">Pizzul</p>
        <p className="mt-0.5 text-base font-bold leading-snug text-white/85">{tip.line}</p>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-full
          text-white/55 hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2
          focus-visible:ring-cyan"
        aria-label="Dismiss Pizzul tip"
      >
        <X className="h-5 w-5" />
      </button>
    </div>
  );
};

export default PizzulTip;
